import { isDueAt } from './gates.js';
import { EDITOR_ALPHA_PACKAGES, EXIT_1A_PACKAGES, EXIT_1B_STAGED_PACKAGES, EXIT_2A_PACKAGES, EXIT_2B_PACKAGES, EXIT_2C_PACKAGES, GATE_PACKAGE_GATES, SPLIT_PARENT_PACKAGES, } from './rows-gate-packages.js';
import { WORK_PACKAGES } from './work-packages.js';
export { GATE_PACKAGE_GATES };
function merge(before, adds) {
    const out = { ...before };
    for (const [id, stages] of Object.entries(adds)) {
        const had = out[id];
        out[id] = stages === 'all' || had === 'all' ? 'all' : [...new Set([...(had ?? []), ...stages])];
    }
    return out;
}
function exit1b(before) {
    const staged = merge(before, EXIT_1B_STAGED_PACKAGES);
    const split = new Set(SPLIT_PARENT_PACKAGES);
    const rest = {};
    for (const id of WORK_PACKAGES) {
        if (!id.startsWith('1.') || split.has(id) || id in EXIT_1B_STAGED_PACKAGES)
            continue;
        // DECISIONS 532: 1.F-s ships right after exit 1b; it joins at exit 2a (EXIT_2A_PACKAGES).
        if (id === '1.F-s')
            continue;
        rest[id] = 'all';
    }
    return merge(staged, rest);
}
const ALPHA = merge({}, EDITOR_ALPHA_PACKAGES);
const EXIT_1A = merge(ALPHA, EXIT_1A_PACKAGES);
const EXIT_1B = exit1b(EXIT_1A);
const EXIT_2A = merge(EXIT_1B, EXIT_2A_PACKAGES);
const EXIT_2B = merge(EXIT_2A, EXIT_2B_PACKAGES);
/**
 * The packages, with stages where staged, that must have merged before each Phase 1 gate and
 * each Phase 2 exit: the cumulative sets (1.0b deliverable 21; CS r4a, r5a and r5c). `'all'` is every stage of the
 * package. A Phase 0 package is merged before any of them and is not listed.
 */
export const GATE_PACKAGES = {
    'editor-alpha': ALPHA,
    'exit-1a': EXIT_1A,
    'exit-1b': EXIT_1B,
    'exit-2a': EXIT_2A,
    'exit-2b': EXIT_2B,
    'exit-2c': merge(EXIT_2B, EXIT_2C_PACKAGES),
};
export function isGatePackageGate(gate) {
    return GATE_PACKAGE_GATES.includes(gate);
}
/** True when `owner` (at `stage`, when the row names one) is merged before `gate`. */
export function isMergedBefore(gate, owner, stage, sets = GATE_PACKAGES) {
    if (owner.startsWith('P0-'))
        return true;
    const entry = sets[gate][owner];
    if (entry === undefined)
        return false;
    return entry === 'all' || stage === undefined || entry.includes(stage);
}
/**
 * The due-row audit: every non-draft row due at `gate` must be owned by a Phase 0 package or by a
 * package (and, for a row with `stage`, a stage) in the gate's cumulative set. Returns one entry
 * per offending row, naming it.
 */
export function dueRowViolations(rows, gates = GATE_PACKAGE_GATES, sets = GATE_PACKAGES) {
    const out = [];
    for (const row of rows) {
        if (row.draft)
            continue;
        for (const gate of gates) {
            if (!isDueAt(row.since, gate))
                continue;
            if (isMergedBefore(gate, row.owner, row.stage, sets))
                continue;
            out.push({
                token: `${row.kind}:${row.id}`,
                since: row.since,
                owner: row.owner,
                stage: row.stage ?? null,
                gate,
            });
            break;
        }
    }
    return out;
}
//# sourceMappingURL=gate-packages.js.map